import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import copyToClipboard from '@functions/copyToClipboard'
import { confirmDelete } from '@functions/entity'

import useTrainingLesson from '@hooks/useTrainingLesson'

type TrainingLessonToolsProps = {
  trainingLessonPayload: ReturnType<typeof useTrainingLesson>,
}

const TrainingLessonTools = (props: TrainingLessonToolsProps) => {
  const { trainingLessonPayload } = props

  const {
    callbacks: {
      deleteTrainingLesson: deleteFn,
    },
    loading,
    urls: { linkUrl },
  } = trainingLessonPayload

  const confirmDeletePayload = {
    callbacks: { deleteFn },
    options: { shouldRedirect: true },
    strings: { entityName: 'Training Lesson' },
  }

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faCopy} />}
        loading={loading}
        onClick={() => copyToClipboard(linkUrl)}
        size="medium"
      >
        Copy Link to Lesson
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faTrashAlt} />}
        loading={loading}
        // @ts-expect-error TS2322
        marginTop="medium"
        // @ts-expect-error TS2345
        onClick={() => confirmDelete(confirmDeletePayload)}
        size="medium"
      >
        Delete Training Lesson
      </Button>
    </Tools>
  )
}

export default TrainingLessonTools
